import React, { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setPreferredLanguage} from '../../features/Auth/store/authSlice'
import { MenuItem, Select } from '@mui/material';

export default function LanguageSelect() {

    const { i18n , t } = useTranslation();
    const { preferredLanguage } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const handleSwitchLanguage = useCallback((language) => {
        console.log(language);
        i18n.changeLanguage(language);
        dispatch(setPreferredLanguage(language));
    }, [i18n]);

    useEffect(() => {
        if (preferredLanguage) {
            i18n.changeLanguage(preferredLanguage);
        }
    }, [preferredLanguage, i18n]);

  return (
    <>
       <Select
            value={
                preferredLanguage
                    ? preferredLanguage
                    : i18n.language
                    ? i18n.language
                    : 'fr'
            }
            onChange={(e) => handleSwitchLanguage(e.target.value)}
           sx={{
                                    width: "100%",
                                    "& .MuiSelect-select": {
                                        display: "flex",
                                        alignItems: "center",
                                        minHeight: "unset",
                                        padding: "0.5rem",
                                    },
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        minHeight: "15%",
                                    },
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 190,
                                            overflowY: "auto",
                                        },
                                    },
                                }}
        >
            <MenuItem value="fr"> {t("FR")}</MenuItem>
            <MenuItem value="en">{t("EN")}</MenuItem>
        </Select>
    </>
  )
}
